import {Card, CardHeader, Divider, Grid, Typography} from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import React, {useEffect, useState} from "react";
import LoadingSpinner from "../../../../components/Spinner/loading.spinner";
import {GridItem} from "../../../../components/Grid";
import {dashboardService} from "../../../../store/services";
import './style.css';
import clsx from "clsx";
import {ChangeHistory, Commit, CommitRounded, DateRange, Person} from "@mui/icons-material";


const GitlabMetrics = (props) => {
  const [metrics, setMetrics] = useState(/**@type GitlabData*/null);
  const [initialLoad, setInitialLoad] = useState(true);

  function getGridItemWithTextAndIcon(key, text, icon){
    return (<GridItem className={clsx("grid-item")}
      children={[(<Typography
        className={clsx("grid-text")}
        gutterBottom
        key={key}
        variant="inherit"
      >
        {icon} {text}
      </Typography>)]}
    />);
  }

  useEffect(() => {
    if (initialLoad === true) {
      dashboardService.getGitlabMetrics().then(result => {
        setMetrics(result.data);
      })
      setInitialLoad(false);
    }
  }, [initialLoad]);

  return (<Card className={clsx("card")}>
    <CardHeader className={clsx("header")}
                title={`Gitlab Data (DEMO)`}
    />
    <Divider className={clsx("divider")}/>
    <CardBody className={clsx("body")}>
      {metrics ? (
        <Grid
          container
          justifyContent="space-between"
          className={clsx("body-grid")}
        >
          {getGridItemWithTextAndIcon(0, `${metrics.commits} Commits`, (<Commit className={clsx("icon", "icon-commits")}/>))}
          {getGridItemWithTextAndIcon(1, `${metrics.nonMergeCommits} Non-Merge Commits`, (<CommitRounded className={clsx("icon", "icon-non-merge")}/>))}
          {getGridItemWithTextAndIcon(2, `${metrics.filesDelta} Δ Files`, <ChangeHistory className={clsx("icon", "icon-delta-files")}/>)}
          {getGridItemWithTextAndIcon(3, `${metrics.uniqueAuthors} Unique Authors`, <Person className={clsx("icon", "icon-unique-authors")}/>)}
          {getGridItemWithTextAndIcon(4, `First Commit ${metrics.firstCommit ? metrics.firstCommit.toDateString() : "unknown"}`, <DateRange className={clsx("icon", "icon-first-commit")}/>)}
          {getGridItemWithTextAndIcon(5, `Latest Commit ${metrics.latestCommit ? metrics.latestCommit.toDateString() : "unknown"}`, <DateRange className={clsx("icon", "icon-latest-commit")}/>)}
        </Grid>
      ) : (<LoadingSpinner/>)
      }
    </CardBody>
  </Card>)
};

export default GitlabMetrics;
